import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Source = iotsUtils.fromList(constants.organization.sources);
